import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ApiOptionItem } from '../../interfaces/api.interface';
import { SampleSuite } from '../../interfaces/option.interface';
import { OptionActions } from '../actions/option.actions';

export const optionsFeatureKey = 'options';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface SampleSuiteState extends EntityState<SampleSuite> {}

export interface OptionState {
  sampleTypes: string[];
  sampleMatrices: ApiOptionItem[];
  sampleSuite: SampleSuiteState;
  error: unknown;
  pending: boolean;
  sampleSuitePending: boolean;
}


const adapterSampleSuite: EntityAdapter<SampleSuite> =
  createEntityAdapter<SampleSuite>({
    selectId: (suite: SampleSuite) => suite.code,
  });

const sampleSuiteState: SampleSuiteState = adapterSampleSuite.getInitialState(
  {},
);

export const initialState: OptionState = {
  sampleTypes: [],
  sampleMatrices: [],
  sampleSuite: sampleSuiteState,
  error: null,
  pending: false,
  sampleSuitePending: false,
};

export const reducer = createReducer(
  initialState,
  on(OptionActions.loadSampleSuites, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
      sampleSuitePending: true,
    };
  }),
  on(OptionActions.loadSampleSuitesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleSuite: adapterSampleSuite.setAll(data, {
        ...state.sampleSuite,
      }),
      error: null,
      pending: true,
      sampleSuitePending: false,
    };
  }),
  on(OptionActions.loadSampleSuitesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
      sampleSuitePending: false,
    };
  }),
  on(OptionActions.loadSampleTypes, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleTypesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleTypes: data,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleTypesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),
  on(OptionActions.loadSampleMatrices, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleMatricesSuccess, (state, { data }) => {
    return {
      ...state,
      sampleMatrices: data,
      error: null,
      pending: true,
    };
  }),
  on(OptionActions.loadSampleMatricesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),
);

export const { selectAll: selectAllSampleSuite } =
  adapterSampleSuite.getSelectors();
